import LOCALES from './locales';

const messages = {
  [LOCALES.ENGLISH]: {
    title: 'Requisites',
    requisites: {
      companyName: {
        title: 'Company name',
        value: 'ZHAI KOMPANI Limited Liability Company',
      },
      registrationNumber: {
        title: 'Registration number',
        value: '307512-3301-000',
      },
      OKPO: {
        title: 'OKPO (GCEO) code',
        value: '33209347',
      },
      TIN: {
        title: 'TIN',
        value: '02108202410232',
      },
      legalAddress: {
        title: 'Legal address',
        value: '43, Pavlov str., Pervomai district, Bishkek, Kyrgyz Republic',
      },
      leader: {
        title: 'Leader',
        value: 'Dmitriev Dmitrii Aleksandrovich',
      },
      registrationAuthority: {
        title: 'Registration authority',
        value: 'Chui-Bishkek Administration of Justice',
      },
    },
  },
  [LOCALES.RUSSIAN]: {
    title: 'Реквизиты',
    requisites: {
      companyName: {
        title: 'Название',
        value: 'Общество с ограниченной ответственностью «Жай Компани»',
      },
      registrationNumber: {
        title: 'Регистрационный номер',
        value: '307512-3301-000',
      },
      OKPO: {
        title: 'Код ОКПО',
        value: '33209347',
      },
      TIN: {
        title: 'ИНН',
        value: '02108202410232',
      },
      legalAddress: {
        title: 'Юридический адрес',
        value:
          '43, ул. Павлова, Первомайский р-н, Бишкек, Кыргызская Республика',
      },
      leader: {
        title: 'Руководитель',
        value: 'Дмитриев Дмитрий Александрович',
      },
      registrationAuthority: {
        title: 'Регистрационный орган',
        value: 'Чуй-Бишкекское управление юстиции',
      },
    },
  },
};

export default messages;
